import { CheckBox, CheckBoxUncheck } from "@/components/Icon"
import React from "react"
import Flex from "@/components/Flex"
import Typography from "@/components/Typography"
import Box from "@/components/Box"

type CheckboxMenuProps = {
  data: { [key: string]: string[] }
  filterArray: string[]
  setFilter: (key: string[]) => void
  allField: string
}

export const CheckboxMenu = ({
  data,
  filterArray,
  setFilter,
  allField,
}: CheckboxMenuProps) => {
  const onFilterChange = (value: string) => {
    if (value === allField) {
      if (filterArray.includes(allField)) {
        setFilter([])
      } else {
        setFilter([allField])
      }
    } else {
      const activeFilter = filterArray.filter(x => x !== allField)
      if (activeFilter.includes(value)) {
        const currentIdx = activeFilter.indexOf(value)
        activeFilter.splice(currentIdx, 1)
      } else {
        activeFilter.push(value)
      }
      setFilter(activeFilter)
    }
  }
  return (
    <Flex flexDirection={"column"} pl={[2, 0, 0]}>
      {Object.keys(data).map((key, index) => {
        return (
          <Box
            key={key}
            display="flex"
            mb={Object.keys(data).length - 1 > index ? 2 : 0}
          >
            {filterArray.includes(key) ? (
              <CheckBox
                fontSize={[20, 24]}
                color={"white"}
                onClick={() => onFilterChange(key)}
              />
            ) : (
              <CheckBoxUncheck
                fontSize={[20, 24]}
                onClick={() => onFilterChange(key)}
              />
            )}
            <Typography
              ml={["12px", 2]}
              pt={["2px", "3px"]}
              variant="careerJobCheckBoxText"
            >{`${key} (${data[key].length})`}</Typography>
          </Box>
        )
      })}
    </Flex>
  )
}
